
export function effectiveWeight(w_oz: number): number {
  const lbs = Math.floor(w_oz / 16);
  const oz = w_oz - (lbs * 16);
  const dec = lbs + (oz / 16);

  // round up to the nearest half-pound
  let ret = Math.ceil(dec * 2) / 2;
  return ret;
}

